import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {hasAppOnlyRedeemableDevices} from './utils/hasAppOnlyRedeemableDevices';

export const isAppOnlyCoupon = (coupon: Coupon) => {
  const redeemableDevices = (() => {
    switch (coupon.type?.$case) {
      case 'simpleCoupon':
        return coupon.type.simpleCoupon.redeemableDevices;
      case 'hotDealCoupon':
        return coupon.type.hotDealCoupon.redeemableDevices;
      case 'minimumOrderValueCoupon':
        return coupon.type?.minimumOrderValueCoupon.redeemableDevices;
      case 'highTierCoupon':
        return coupon.type?.highTierCoupon.redeemableDevices;
    }
  })();

  if (!redeemableDevices) {
    return false;
  }

  return hasAppOnlyRedeemableDevices(redeemableDevices);
};
